import { Platform } from '@eika-infrastruktur/mobilbank-lib';

const getPlatform = (): Platform => window.ReactNativeProps?.platform || 'web';
export const isIOS = (): boolean => getPlatform() === 'ios';
